import {UPDATE_MESSAGE_VALUE} from '../actions';
import typingIndicator from '../services/typingIndicator';
import _ from 'lodash';

export default function message(state = '', action) {
  switch (action.type) {
    case UPDATE_MESSAGE_VALUE:
      return action.value;
    default:
      return state;
  }
}

const stopTypingScheduler = _.debounce(typingIndicator.stopTyping.bind(typingIndicator), 3000);

export const notifyTypingStatus = message => {
  if (!_.isEmpty(message) && !typingIndicator.isCurrentUserTyping) {
    typingIndicator.startTyping();
    stopTypingScheduler();
  } else if (!_.isEmpty(message) && typingIndicator.isCurrentUserTyping) {
    stopTypingScheduler(); //postpone debounce
  } else if (typingIndicator.isCurrentUserTyping && _.isEmpty(message)) {
    stopTypingScheduler.flush();
  }
};



// WEBPACK FOOTER //
// ./chat-app/reducers/message.js